/*
 * constants
 */
import { AuthUser } from "@emr/types"
import { AppPlatform } from "@emr/utils"

export const EMPTY_GUID = "00000000-0000-0000-0000-000000000000"

export const SYSTEM_USER = {
	id: EMPTY_GUID,
	app_metadata: { [AppPlatform]: { role: "admin" } },
} as AuthUser

export const globalCreateExclude = {
	id: true as const,
	createdAt: true as const,
	createdBy: true as const,
	updatedAt: true as const,
	updatedBy: true as const,
}
export const globalCreatePartial = {
	id: true as const,
}
export const globalUpdateExclude = {
	createdAt: true as const,
	createdBy: true as const,
	updatedAt: true as const,
	updatedBy: true as const,
}

export const globalAtExclude = {
	createdAt: true as const,
	updatedAt: true as const,
}
export const globalByExclude = {
	createdBy: true as const,
	updatedBy: true as const,
}
